import axiosClient from "..";
import { getErrorMessageObj } from "../../../container/SportsBookNode/utils/common/functions";

export default class topMatchesService {
  static getTopMatches(payload) {
    return axiosClient
      .get("/sb/getTopEvents", {
        params: {
          ...payload
        }
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        return getErrorMessageObj(error);
      });
  }
}
